"use client";

import React, { createContext, useContext, useState } from "react";
import useIsomorphicLayoutEffect from "@/hooks/useIsomorphicLayoutEffect";

export interface WindowSize {
  width: number;
  height: number;
}

const WindowSizeContext = createContext<WindowSize>({ width: 0, height: 0 });

export const WindowSizeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [size, setSize] = useState<WindowSize>({ width: 0, height: 0 });

  useIsomorphicLayoutEffect(() => {
    let rafId: number;
    let active = true;

    const update = () => {
      rafId = requestAnimationFrame(() => {
        if (!active) return;
        setSize({ width: window.innerWidth, height: window.innerHeight });
      });
    };

    update();
    window.addEventListener("resize", update, { passive: true });

    return () => {
      active = false;
      window.removeEventListener("resize", update);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <WindowSizeContext.Provider value={size}>
      {children}
    </WindowSizeContext.Provider>
  );
};

export const useWindowSizeContext = (): WindowSize =>
  useContext(WindowSizeContext);
